import { Component, inject, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../../core/services/auth.service';
import { JwtTokens, LoginParams } from '../../../core/types/auth.types';
import { Router } from '@angular/router';
import { ErrorService } from "../../../core/services/error.service";
import { AuthApiService } from "../../../core/services-api/auth-api.service";
import { MatFormField, MatInput, MatLabel } from "@angular/material/input";
import { MatButton } from "@angular/material/button";
import { loginFormFields } from "./configs/login-pag-form-fields";
import { BaseModalService } from "../../../core/components/modals/services/base-modal.service";
import { LoginFormField } from "./types/login-page.types";
import { InfoApplicationComponent } from "../../../core/components/info-application/info-application.component";

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatButton,
    InfoApplicationComponent
  ],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss'
})
export class LoginPageComponent implements OnInit {
  private authService: AuthService = inject(AuthService);
  private authApiService: AuthApiService = inject(AuthApiService);
  private errorService: ErrorService = inject(ErrorService);
  private router: Router = inject(Router);
  private baseModalService: BaseModalService = inject(BaseModalService);

  public readonly loginFormFields = loginFormFields;
  public loginForm = new FormGroup({});

  public ngOnInit(): void {
    this.loginForm = this.baseModalService.getFormGroup<LoginFormField>(loginFormFields);
  }

  public handelLogin(): void {
    const params: LoginParams = {
      username: this.loginForm.get('username' as string)?.value || '',
      password: this.loginForm.get('password' as string)?.value || ''
    };

    this.authApiService.login(params).subscribe({
      next: (tokens: JwtTokens) => {
        this.authService.doLoginUser(params.username, tokens);
        this.router.navigate(['/']).then();
      },
      error: (error) => {
        error.error.message ?
          this.errorService.showErrorMessage(error.error.message) :
          this.errorService.handleError(error);
      }
    });
  }
}
